import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { TokenService } from '../services/token.service';

@Injectable()
export class AuthGuardService implements CanActivate {
    constructor(
        public router: Router,
        private tokenService: TokenService,
    ) {}

    canActivate(): Observable<boolean> | boolean {
        const token = localStorage.getItem('userAccessToken');
        if (!token) {
            this.router.navigate(['/login']);
            return false;
        }

        if (this.tokenService.isTokenValid()) {
            return true;
        }

        // Token exists but is expired or about to expire — try to renew
        if (localStorage.getItem('userRefreshToken')) {
            return this.tokenService.renewToken().pipe(
                map(() => true),
                catchError(() => {
                    this.tokenService.clearAndRedirect();
                    return of(false);
                }),
            );
        }

        this.tokenService.clearAndRedirect();
        return false;
    }
}
